<template>
  <div class="uploadImgDiv">
    <el-upload
      v-if="!value"
      action="/common-service/upload-pic"
      :show-file-list="false"
      accept="image/*"
      :auto-upload="false"
      :on-change="(file) => changeUploadImg(file, 'page')">
      <el-button :loading="loading" :disabled="disabled">图片上传<i class="el-icon-upload2 el-icon--right"></i></el-button>
    </el-upload>
    <div v-else class="flex-start-start">
      <div class="resultDiv flex-center page">
      <img :src="value" alt="" class="imgShow"/>
      <div class="hoverShowDiv">
        <div class="editDiv">
          <span @click.stop="showBigImg('page')" ><i class="el-icon-zoom-in"></i></span>
          <span @click.stop="deleteImg('page')" v-if="!disabled"><i class="el-icon-delete"></i></span>
        </div>
      </div>
      </div>
      <el-upload
        action="/common-service/upload-pic"
        :show-file-list="false"
        accept="image/*"
        :auto-upload="false"
        :on-change="(file) => changeUploadImg(file, 'page')">
        <el-button :loading="loading">重新上传</el-button>
      </el-upload>
    </div>
    <div v-if="desc" class="tip">{{desc}}</div>
    <!--  图片放大弹窗    -->
    <el-dialog title="查看图片详情" :visible.sync="dialogBigImgVisible" width="800px" append-to-body>
      <img :src="value" alt="" class="bigImg">
    </el-dialog>
  </div>
</template>

<script>
// import qs from 'qs'
export default {
  name: 'UploadImgBtn',
  props: {
    // 上传的其他数据
    otherData: {
      type: Object,
      default: function () {
        return {
          picType: 'subsidyMerchant'
        }
      }
    },
    // 是否可编辑
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: '',
      required: true
    },
    valueName: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '点击上传'
    },
    // 文件大小上限
    picMaxSize: {
      type: Number,
      default: 1024
    },
    // 是否可放大
    showBigger: {
      type: Boolean,
      default: true
    },
    // 是否可下载
    download: {
      type: Boolean,
      default: false
    },
    // label下的描述内容
    desc: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      loading: false,
      dialogBigImgVisible: false
    }
  },
  mounted () {
    if (this.value && this.resultShow === '') {
      // 在只读的情况下，直接传带http的路径
      const that = this
      if (this.value.indexOf('http://') >= 0) {
        this.resultShow = this.value
      } else {
        const param = { picPath: that.value }
        this.$axios.post(this.$api.singleTransPic, param).then(response => {
          if (response.respCode === '0') {
            this.resultShow = response.data.picUrl
          }
        })
      }
    } else {
      this.result = ''
      this.resultShow = ''
    }
  },
  methods: {
    // 上传图片
    async changeUploadImg (file) {
      const fileName = file.name.split('.')
      if (!['png', 'jpg', 'jpeg'].includes(fileName[fileName.length - 1].toLowerCase())) {
        this.$message({
          showClose: true,
          message: '请上传PNG、JPG格式图片',
          type: 'error'
        })
      } else if (file.raw.size > 1024 * 1024) {
        this.$message({
          showClose: true,
          message: '图片大小不能超过1M',
          type: 'error'
        })
      } else {
        this.loading = true
        await this.upload(file)
      }
    },
    upload (file) {
      // var that = this
      return new Promise((resolve, reject) => {
        var reader = new FileReader()
        const that = this
        reader.readAsDataURL(file.raw)
        reader.onload = function (e) {
          var resultFile = this.result // 此处的this.result是文件流而不是内部参数
          resultFile = resultFile.split('base64,')
          var params = {
            picType: 'subsidyMerchant',
            base64pic: resultFile[1]
          }
          that.$axios.post(that.$api.uploadPicOSS, params).then(data => {
            that.loading = false
            if (data.respCode === '0') {
              resolve()
              that.$message({
                message: data.respMsg,
                type: 'success'
              })
              that.emitResult({
                value: data.data.url
              })
            } else {
              that.$message({
                message: data.respMsg,
                type: 'error'
              })
              that.emitResult(data)
            }
          }).catch((e) => {
            that.$message({
              showClose: true,
              message: e, // data此处未定义
              type: 'error'
            })
            reject(e)
            // that.emitResult(params)
          })
        }
      }).catch(() => {
      })
    },
    // 图片放大
    showBigImg () {
      this.dialogBigImgVisible = true
    },
    // 下载图片，仍然有跨域问题
    downLoadImg () {
      var canvas = document.createElement('canvas')
      var img = document.createElement('img')
      img.onload = function (e) {
        canvas.width = img.width
        canvas.height = img.height
        var context = canvas.getContext('2d')
        context.drawImage(img, 0, 0, img.width, img.height)
        canvas.getContext('2d').drawImage(img, 0, 0, img.width, img.height)
        canvas.toBlob((blob) => {
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'aaa'
          link.click()
        }, 'image/png')
      }
      img.setAttribute('crossOrigin', 'Anonymous')
      img.src = this.resultShow
    },
    // 删除图片
    deleteImg () {
      this.$confirm('是否确认删除该图片？', '温馨提醒', {
      }).then(() => {
        this.result = ''
        this.resultShow = ''
        this.$emit('upload', {
          value: ''
        })
      })
    },
    emitResult (result) {
      this.$emit('upload', result)
    }
  }
}
</script>

<style scoped lang="less">
img.bigImg {
  width: 100%;
  display: block;
}
.uploadImgDiv{
  display: inline-block;
}
.resultDiv {
  width: 150px;
  height: 150px;
  margin-right: 12px;
  position: relative;
  display: inline-block;
}
.resultDiv:hover{
  box-shadow: 0 0 8px 0 rgba(232,237,250,.6),0 2px 4px 0 rgba(232,237,250,.5);
}
.resultDiv:hover .hoverShowDiv{
  /*.resultDiv .hoverShowDiv{*/
  opacity: 0.8;
}
.resultDiv:hover .hoverShowDiv .editDiv{
  /*.resultDiv .hoverShowDiv .editDiv{*/
  height: 180px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.hoverShowDiv{
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0,0,0,.5);
  transition: opacity .3s;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.hoverShowDiv .editDiv,.hoverShowDiv .reUpload{
  display: none;
  cursor: pointer;
}
.hoverShowDiv i{
  color: #fff;
  font-size: 25px;
}
.imgShow {
  width: 150px;
  height: 150px;
  vertical-align: top;
}
</style>
